/*
 * CardChessBoard
 *
 * what?
 */

import React, {useEffect, memo, useMemo, Fragment} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl, useIntl} from 'react-intl';
import Grid from '@material-ui/core/Grid';
import Drawer from '@material-ui/core/Drawer';
import './CardChessBoard.scss';
import Dialog from '@material-ui/core/Dialog';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import Box from '@material-ui/core/Box';
import CardContent from './components/CardContent';
import SvgText from '../../components/SvgText';
import LogDisplay from './components/LogDisplay';
import {CARD_NAME, cardSetting} from "./GameRule";
import {Tooltip} from "@material-ui/core";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const scope = 'game.CardChessBoard';

function getCards(hand) {
  return hand.map(oneHandCard => {
    const { name } = oneHandCard || {};
    const setting = cardSetting[name];
    return { ...oneHandCard, setting };
  });
}

// 获取prepare数组的展示
function getPrepares(prepare, intl) {
  return prepare.map(one => {
    const { name: cardName = CARD_NAME.COMMON_PREPARE } = one || {};
    return intl.formatMessage({
      id: `game.GamePage.card.name.${cardName}`,
      defaultMessage: `备战牌`,
    })
    // return <FormattedMessage
    //   id={`game.GamePage.card.name.${cardName}`}
    //   defaultMessage={cardName}
    // />
    // return one.name
  }).join(' → ');
}

function CardChessBoard({
                          username,
                          loading,
                          error,
                          repos,
                          onSubmitForm,
                          onChangeUsername,
                          G,
                          ctx,
                          moves,
                          events,
                          isActive,
                          playerID,
                          matchData,
                          ...otherProps
                        }) {
  console.log('CardChessBoard render props', ctx, otherProps, matchData);
  const intl = useIntl();
  useEffect(() => {
    // When initial state username is not null, submit the form to load repos
    if (username && username.trim().length > 0) onSubmitForm();
  }, []);


  const { phase, gameover } = ctx;

  const { players: originPlayers, lastAction = {} } = G;

  // 多人游戏名字
  const players = originPlayers.map((player, idx) => {
    let name = player?.info?.name;
    if (matchData && matchData[idx]) {
      name = matchData[idx].name;
    }
    return {
      ...player,
      info: {
        ...player.info,
        name
      }
    };
  });
  let whoPlayId = playerID;
  if (!playerID) whoPlayId = ctx.currentPlayer;
  const myPlayerData = players[whoPlayId];
  const { hand, members, shop } = myPlayerData;
  const isMePlaying = whoPlayId === ctx.currentPlayer;
  const shopOpen = (isMePlaying && shop.length > 0) || (phase === 'selectFirstMember' && shop.length > 0);

  function onShopItemSelect(idx) {
    if (phase === 'battle') {
      moves.BuyFromShop(idx);
    } else if (phase === 'selectFirstMember') moves.SelectMember(idx);
  }

  return (
    <div className="card-chess-board">
      <div className="common-field">
        <div>
          当前玩家：
          {players[ctx.currentPlayer].info.name}
        </div>
        {phase === 'battle' && isActive && (
          <div>
            <Button variant="contained" color="primary" onClick={() => events.endTurn()}>回合结束</Button>
          </div>
        )}
        {gameover && (
          <Fragment>
            {(gameover || {}).winner && <Typography variant="h2" color="textPrimary">
              Winner:
              {players[(gameover || {}).winner]?.info.name}
            </Typography>}
            {(gameover || {}).draw && <Typography variant="h2" color="textPrimary">
              Draw！
            </Typography>}
          </Fragment>
        )}
      </div>
      <div className="chess-board-field">
        战场:
        <Grid container spacing={5}>
          {players.map((onePlayer, idx) => {
            const { hand = [] } = onePlayer;
            return (
              <Grid item key={idx}>
                {onePlayer.members.map((oneMember) => {
                  const {
                    id: key,
                    species: { id, emoji },
                    status: { hp },
                    advanced: { prepare = [] },
                  } = oneMember;
                  return (
                    <Box border={1} borderColor="primary.main" key={key} className="one-player">
                      <Box textAlign="center">
                        <Typography variant="h6" fontFamily="Monospace">{onePlayer.info.name}</Typography>
                        <div className="member-emoji">
                          <div className="member-emoji__inner"><SvgText>{emoji}</SvgText></div>
                        </div>
                        <Typography variant="h8" fontFamily="Monospace">
                          <FormattedMessage
                            id={`game.GamePage.member.${id}`}
                            defaultMessage={id}
                          />
                        </Typography>
                        <Typography variant="h6" fontFamily="Monospace">
                          <div>
                            hp:
                            {hp}
                          </div>
                        </Typography>
                        <div className='count-hand-cards'>
                          手牌：{hand.length}张
                        </div>
                        {prepare.length > 0 && <Tooltip title={getPrepares(prepare, intl)}>
                          <div className='prepare-cards'>
                            备战牌：{prepare.length}张
                          </div>
                        </Tooltip>}
                      </Box>
                      <div/>
                    </Box>
                  );
                })}
              </Grid>
            )
          })}
        </Grid>

      </div>
      <div className="log-field">
        <LogDisplay G={G} ctx={ctx} players={players}/>
      </div>
      <div className="info-field">
        {null}
      </div>
      <div className="shop-field">
        <Dialog
          open={shopOpen}
          // onClose={handleClose}
          disableBackdropClick
          disableEscapeKeyDown
          PaperComponent={PaperComponent}
          // scroll="scroll-paper"
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
            <FormattedMessage id="game.GamePage.label.select" defaultMessage="Select..."/>
          </DialogTitle>
          <div className="shop-field__inner">
            <div className="shop-item-list">
              <Grid container spacing={2} className="grid-container">
                {getCards(shop).map((oneShopItem, idx) => {
                  const { id } = oneShopItem;
                  return (
                    <Grid key={id} item>
                      <div className="">
                        <CardContent
                          onClick={() => onShopItemSelect(idx)}
                          data={oneShopItem}
                        >
                          {/* {JSON.stringify(oneHandCard)} */}
                        </CardContent>
                      </div>
                    </Grid>
                  );
                })}
              </Grid>
            </div>
          </div>
        </Dialog>
      </div>
      <div className="hand-field">
        <Drawer anchor="bottom" open variant="persistent">
          <div className="hand-field__inner">
            <Grid container justify="center" spacing={2} className="grid-container">
              {getCards(hand).map((oneHandCard, idx) => (
                <Grid key={oneHandCard?.id} item>
                  <CardContent
                    disabled={!isMePlaying}
                    onClick={() => moves.UseCard(idx)}
                    data={oneHandCard}
                  >
                    {/* {JSON.stringify(oneHandCard)} */}
                  </CardContent>
                </Grid>
              ))}
            </Grid>
          </div>
        </Drawer>
      </div>
    </div>
  );
}

CardChessBoard.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  repos: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  onSubmitForm: PropTypes.func,
  username: PropTypes.string,
  onChangeUsername: PropTypes.func,
};

function addFunctions(WrappedComponent, functions = {}) {
  return (props) => {
    const propsFunc = {};
    Object.keys(functions).forEach((funcName) => {
      propsFunc[funcName] = (...args) => functions[funcName](props, ...args);
    });
    return <WrappedComponent {...props} {...propsFunc} myX={123}/>;
  };
}

const mapFunctionToProps = {
  addOne: (props, value) => true,
};

export default addFunctions(CardChessBoard, mapFunctionToProps);
